import {
  AccountTree,
  Factory,
  Inventory2,
  LocalShipping,
  PhotoLibrary,
  PrecisionManufacturing,
  ReceiptLong,
  Storefront,
  SwapHoriz,
  Timeline,
  ViewModule,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { anyOf, reads, situation } from '../../util/access';
import { STOCK_MENU_GRANTS } from './hubAccess';
import WorkspaceHub, { type HubSection } from './WorkspaceHub';

const StockHub = () => {
  const { t } = useTranslation();

  const sections: HubSection[] = [
    {
      id: 'inventory',
      title: t('nav:tabs.inventory'),
      cards: [
        {
          id: 'inventory-records',
          title: t('nav:tabs.inventory'),
          description: t('common:hubs.cards.inventory'),
          path: '/stock/inventory',
          grant: reads('inventory'),
          color: '#2e7d32',
          icon: Inventory2,
        },
        {
          id: 'current-inventory',
          title: t('nav:tabs.current_inventory'),
          description: t('common:hubs.cards.currentInventory'),
          path: '/stock/inventory/current',
          grant: reads('inventory_current'),
          color: '#00897b',
          icon: ViewModule,
        },
        {
          id: 'inventory-visual',
          title: t('nav:tabs.current_inventory_visual'),
          description: t('common:hubs.cards.inventoryVisual'),
          path: '/stock/inventory/current/visual',
          grant: reads('inventory_current'),
          color: '#43a047',
          icon: PhotoLibrary,
        },
        {
          id: 'catalog',
          title: t('nav:tabs.product_catalog'),
          description: t('common:hubs.cards.catalog'),
          path: '/stock/inventory/product-catalog',
          grant: STOCK_MENU_GRANTS['10.3'],
          color: '#6a1b9a',
          icon: Storefront,
        },
      ],
    },
    {
      id: 'movement',
      title: t('nav:tabs.stock_movement'),
      cards: [
        {
          id: 'movement',
          title: t('nav:tabs.stock_movement'),
          description: t('common:hubs.cards.movement'),
          path: '/stock/movement',
          grant: anyOf(reads('movement'), reads('discard')),
          color: '#1565c0',
          icon: SwapHoriz,
        },
        {
          id: 'movement-list',
          title: t('nav:tabs.stock_movement_listing'),
          description: t('common:hubs.cards.movementList'),
          path: '/stock/movement/list',
          grant: anyOf(reads('movement'), reads('discard')),
          color: '#1976d2',
          icon: ViewModule,
        },
        {
          id: 'movement-trace',
          title: t('nav:tabs.stock_movement_tracing'),
          description: t('common:hubs.cards.movementTrace'),
          path: '/stock/movement/trace',
          grant: reads('stock_tracing'),
          color: '#0288d1',
          icon: AccountTree,
        },
        {
          id: 'movement-chrono',
          title: t('nav:tabs.stock_movement_chrono'),
          description: t('common:hubs.cards.movementChrono'),
          path: '/stock/movement/trace/chrono',
          grant: reads('stock_timeline'),
          color: '#0097a7',
          icon: Timeline,
        },
      ],
    },
    {
      id: 'supply',
      title: t('nav:tabs.supply'),
      cards: [
        {
          id: 'supply',
          title: t('nav:tabs.supply'),
          description: t('common:hubs.cards.supply'),
          path: '/stock/supply',
          grant: reads('supply'),
          color: '#ef6c00',
          icon: LocalShipping,
        },
        {
          id: 'supply-list',
          title: t('nav:tabs.supply_listing'),
          description: t('common:hubs.cards.supplyList'),
          path: '/stock/supply/list',
          grant: reads('supply'),
          color: '#f57c00',
          icon: ViewModule,
        },
        {
          id: 'supply-situation',
          title: t('nav:tabs.supply_situation'),
          description: t('common:hubs.cards.supplySituation'),
          path: '/stock/supply/situation',
          grant: situation('supply'),
          color: '#ff8f00',
          icon: ReceiptLong,
        },
      ],
    },
    {
      id: 'make',
      title: t('common:hubs.sections.make'),
      cards: [
        {
          id: 'production',
          title: t('nav:tabs.production'),
          description: t('common:hubs.cards.production'),
          path: '/stock/production',
          grant: reads('production'),
          color: '#5d4037',
          icon: Factory,
        },
        {
          id: 'boms',
          title: t('nav:tabs.production_boms'),
          description: t('common:hubs.cards.boms'),
          path: '/stock/production/boms',
          grant: STOCK_MENU_GRANTS['16.1'],
          color: '#6d4c41',
          icon: PrecisionManufacturing,
        },
        {
          id: 'conversion',
          title: t('nav:tabs.stock_conversion'),
          description: t('common:hubs.cards.conversion'),
          path: '/stock/conversion',
          grant: reads('conversion'),
          color: '#7b1fa2',
          icon: SwapHoriz,
        },
      ],
    },
  ];

  return (
    <WorkspaceHub
      title={t('nav:tabs.stock')}
      subtitle={t('common:hubs.stockSubtitle')}
      sections={sections}
    />
  );
};

export default StockHub;
